import React, { useEffect } from 'react'

import Cookies from 'js-cookie'
import { useNavigate, useParams } from 'react-router-dom'

export const ReferralRedirect: React.FC = () => {
  const { referralCode } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (referralCode) {
      Cookies.set('referralCode', referralCode, { expires: 30 })
    }

    navigate('/sign-up')
  }, [referralCode, navigate])

  return null
}
